/**
 * Wunschmoment Cart Upsell
 * Event Delegation — funktioniert auch nach Cart Drawer Re-Render (innerHTML).
 */
(function() {
  'use strict';

  var selectedVariantId = null;
  var pendingInit = false;

  /* Rahmen-Upsell wählt je Kohorte die passende (teurere) Rahmen-Variante:
       Alt-Offer (data-offer=offer)        → data-variant-id-offer / -price-offer  (rahmen)
       Shipping-B (data-shipping=included) → data-variant-id-ship  / -price-ship   (rahmen-puzzle)
       sonst (Control/separate)            → data-variant-id       / -price        (puzzle-rahmen) */
  function isOfferVariant() {
    return document.documentElement.getAttribute('data-offer') === 'offer';
  }
  function isShipVariant() {
    return document.documentElement.getAttribute('data-shipping') === 'included';
  }
  function variantIdFor(el) {
    if (isShipVariant() && el.dataset.variantIdShip) return el.dataset.variantIdShip;
    if (isOfferVariant() && el.dataset.variantIdOffer) return el.dataset.variantIdOffer;
    return el.dataset.variantId;
  }
  function variantPriceFor(el) {
    if (isShipVariant() && el.dataset.variantPriceShip) return el.dataset.variantPriceShip;
    if (isOfferVariant() && el.dataset.variantPriceOffer) return el.dataset.variantPriceOffer;
    return el.dataset.variantPrice;
  }

  function initUpsell() {
    /* Bilder laden */
    var images = window.PUZZLE_RAHMEN_IMAGES || {};
    document.querySelectorAll('img[data-color-key]').forEach(function(img) {
      var key = img.dataset.colorKey;
      if (images[key] && img.getAttribute('src') !== images[key]) img.src = images[key];
    });

    /* Größenauswahl: erste Größe automatisch auswählen + Varianten filtern */
    document.querySelectorAll('.wm-cart-upsell__expand').forEach(function(expand) {
      var sizeOptions = expand.querySelectorAll('.wm-cart-upsell__size-option');
      if (sizeOptions.length > 0 && !expand.querySelector('.wm-cart-upsell__size-option.active')) {
        sizeOptions[0].classList.add('active');
        var sizeNameEl = expand.querySelector('#wm-rahmen-size-name');
        if (sizeNameEl) sizeNameEl.textContent = sizeOptions[0].dataset.sizeLabel;
        filterVariantsBySize(expand, sizeOptions[0].dataset.sizeMatch);
      } else if (sizeOptions.length === 0) {
        selectFirstVariant(expand);
      }
    });
  }

  function filterVariantsBySize(expand, sizeMatch) {
    var allVariants = expand.querySelectorAll('.wm-cart-upsell__variant');
    allVariants.forEach(function(v) {
      var title = v.dataset.variantTitle || '';
      var matches = title.indexOf(sizeMatch) !== -1;
      v.style.display = matches ? '' : 'none';
      if (!matches) v.classList.remove('active');
    });
    selectFirstVariant(expand);
  }

  function selectFirstVariant(expand) {
    var visibleVariants = expand.querySelectorAll('.wm-cart-upsell__variant:not([disabled])');
    var first = null;
    for (var i = 0; i < visibleVariants.length; i++) {
      if (visibleVariants[i].style.display !== 'none') { first = visibleVariants[i]; break; }
    }
    if (first && !expand.querySelector('.wm-cart-upsell__variant.active[style=""]') && !expand.querySelector('.wm-cart-upsell__variant.active:not([style])')) {
      first.classList.add('active');
      selectedVariantId = variantIdFor(first);

      var colorNameEl = expand.querySelector('#wm-rahmen-color-name');
      if (colorNameEl) colorNameEl.textContent = first.dataset.colorName;

      var atcBtn = expand.querySelector('.wm-cart-upsell__atc');
      if (atcBtn) {
        atcBtn.disabled = false;
        var price = (parseInt(variantPriceFor(first)) / 100).toFixed(2).replace('.', ',');
        atcBtn.textContent = 'In den Warenkorb \u00b7 ' + price + ' \u20ac';
      }
    }
  }

  function scheduleInit() {
    if (pendingInit) return;
    pendingInit = true;
    requestAnimationFrame(function() {
      pendingInit = false;
      initUpsell();
    });
  }

  function refreshCartDrawer() {
    fetch('/?sections=cart-drawer,cart-icon-bubble')
      .then(function(r) { return r.json(); })
      .then(function(sections) {
        var drawerEl = document.getElementById('CartDrawer');
        if (drawerEl && sections['cart-drawer']) {
          var tmp = document.createElement('div');
          tmp.innerHTML = sections['cart-drawer'];
          var newInner = tmp.querySelector('.drawer__inner');
          if (newInner) {
            var drawerInner = drawerEl.querySelector('.drawer__inner');
            drawerInner.innerHTML = newInner.innerHTML;
            drawerInner.scrollTop = 0;
          }
        }
        var bubble = document.getElementById('cart-icon-bubble');
        if (bubble && sections['cart-icon-bubble']) {
          var tmp2 = document.createElement('div');
          tmp2.innerHTML = sections['cart-icon-bubble'];
          var newBubble = tmp2.querySelector('[id="cart-icon-bubble"]');
          if (newBubble) bubble.innerHTML = newBubble.innerHTML;
        }
      });
  }

  /* ── Event Delegation auf document ── */
  document.addEventListener('click', function(e) {
    var target = e.target;

    /* Puzzle gestalten */
    if (target.closest('#wm-upsell-puzzle-btn')) {
      e.preventDefault();
      var isInlineVariant = document.documentElement.getAttribute('data-product-variant') === 'inline';
      if (!isInlineVariant && typeof window.wmOpenPersonalizer === 'function') {
        window.wmOpenPersonalizer();
      } else {
        var btn = target.closest('#wm-upsell-puzzle-btn');
        var url = btn && btn.dataset.productUrl;
        if (url) window.location.href = url;
      }
      return;
    }

    /* Rahmen: Mehr erfahren Popup */
    if (target.closest('#wm-rahmen-info-link')) {
      e.preventDefault();
      openRahmenInfoPopup();
      return;
    }

    /* Rahmen: Größe auswählen */
    var sizeBtn = target.closest('.wm-cart-upsell__size-option');
    if (sizeBtn) {
      var expandEl = sizeBtn.closest('.wm-cart-upsell__expand');
      if (expandEl) {
        expandEl.querySelectorAll('.wm-cart-upsell__size-option').forEach(function(b) { b.classList.remove('active'); });
        sizeBtn.classList.add('active');
        var sizeNameEl = expandEl.querySelector('#wm-rahmen-size-name');
        if (sizeNameEl) sizeNameEl.textContent = sizeBtn.dataset.sizeLabel;
        expandEl.querySelectorAll('.wm-cart-upsell__variant').forEach(function(v) { v.classList.remove('active'); });
        selectedVariantId = null;
        filterVariantsBySize(expandEl, sizeBtn.dataset.sizeMatch);
      }
      return;
    }

    /* Rahmen: Farbe/Variante wählen / Schließen */
    var chooseBtnEl = target.closest('.wm-cart-upsell__btn[id="wm-rahmen-choose-btn"]') || (target.id === 'wm-rahmen-choose-btn' ? target : null);
    if (chooseBtnEl) {
      var rahmenCard = chooseBtnEl.closest('.wm-cart-upsell__card--rahmen');
      if (rahmenCard) {
        var expand = rahmenCard.querySelector('.wm-cart-upsell__expand');
        if (expand) {
          var hasMultiSizes = expand.querySelector('.wm-cart-upsell__size-options');
          var openLabel = hasMultiSizes ? 'Variante w\u00e4hlen' : 'Farbe w\u00e4hlen';
          expand.classList.toggle('active');
          var isActive = expand.classList.contains('active');
          chooseBtnEl.textContent = isActive ? 'Schlie\u00dfen' : openLabel;
          if (isActive) {
            setTimeout(function() {
              var atcTarget = expand.querySelector('.wm-cart-upsell__atc') || expand;
              var scroller = expand.closest('.drawer__inner') || expand.closest('cart-drawer-items');
              if (scroller) {
                var targetRect = atcTarget.getBoundingClientRect();
                var scrollerRect = scroller.getBoundingClientRect();
                var footer = scroller.querySelector('.drawer__footer') || document.querySelector('.drawer__footer');
                var footerHeight = footer ? footer.offsetHeight : 0;
                var scrollNeeded = targetRect.bottom - scrollerRect.bottom + footerHeight + 20;
                if (scrollNeeded > 0) {
                  scroller.scrollBy({ top: scrollNeeded, behavior: 'smooth' });
                }
              }
            }, 50);
          }
        }
      }
      return;
    }

    /* Rahmen: Variante auswählen */
    var variantBtn = target.closest('.wm-cart-upsell__variant:not([disabled])');
    if (variantBtn && variantBtn.closest('.wm-cart-upsell__expand')) {
      var expandEl = variantBtn.closest('.wm-cart-upsell__expand');
      var allVariants = expandEl.querySelectorAll('.wm-cart-upsell__variant');
      allVariants.forEach(function(b) { b.classList.remove('active'); });
      variantBtn.classList.add('active');
      selectedVariantId = variantIdFor(variantBtn);

      /* Farbe-Label */
      var colorNameEl = expandEl.querySelector('.wm-cart-upsell__color-label span');
      if (colorNameEl) colorNameEl.textContent = variantBtn.dataset.colorName;

      /* ATC Button mit Preis */
      var atcBtn = expandEl.querySelector('.wm-cart-upsell__atc');
      if (atcBtn) {
        atcBtn.disabled = false;
        var price = (parseInt(variantPriceFor(variantBtn)) / 100).toFixed(2).replace('.', ',');
        atcBtn.textContent = 'In den Warenkorb \u00b7 ' + price + ' \u20ac';
      }
      return;
    }

    /* Rahmen: In den Warenkorb */
    if (target.closest('.wm-cart-upsell__atc')) {
      var atc = target.closest('.wm-cart-upsell__atc');
      if (!atc || !selectedVariantId) return;

      atc.textContent = 'Wird hinzugef\u00fcgt\u2026';
      atc.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(selectedVariantId), quantity: 1 }] })
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        selectedVariantId = null;
        /* Cart Page: Seite neu laden. Cart Drawer: Drawer aktualisieren */
        if (document.getElementById('main-cart-items')) {
          window.location.reload();
        } else {
          refreshCartDrawer();
        }
      })
      .catch(function() {
        selectedVariantId = null;
        if (document.getElementById('main-cart-items')) {
          window.location.reload();
        } else {
          refreshCartDrawer();
        }
      });
      return;
    }
  });

  /* ── Init: nach DOM ready + nach jedem Re-Render ── */
  function setup() {
    initUpsell();
    var observer = new MutationObserver(scheduleInit);
    var cartDrawerEl = document.querySelector('cart-drawer');
    if (cartDrawerEl) {
      observer.observe(cartDrawerEl, { childList: true, subtree: true });
    }
    var cartPageEl = document.getElementById('main-cart-items');
    if (cartPageEl) {
      observer.observe(cartPageEl, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setup);
  } else {
    setup();
  }

  /* ── Rahmen Info Popup ── */
  var infoOverlay = null;
  var infoPopup = null;

  function openRahmenInfoPopup() {
    if (infoPopup) return;
    var imgs = window.PUZZLE_RAHMEN_IMAGES || {};
    var mobile = window.innerWidth < 768;

    infoOverlay = document.createElement('div');
    infoOverlay.className = 'wm-rahmen-info-overlay';
    infoOverlay.innerHTML = '&nbsp;';
    infoOverlay.addEventListener('click', closeRahmenInfoPopup);

    infoPopup = document.createElement('div');
    infoPopup.className = mobile ? 'wm-rahmen-info wm-rahmen-info--mobile' : 'wm-rahmen-info';
    infoPopup.addEventListener('click', function(ev) { ev.stopPropagation(); });
    infoPopup.innerHTML =
      '<button class="wm-rahmen-info__close" type="button">&times;</button>' +
      '<div class="wm-rahmen-info__content">' +
        '<h3>Bring dein Puzzle an die Wand</h3>' +
        '<p>Mit einem unserer Holzrahmen h\u00e4ltst du deinen Lieblingsmoment f\u00fcr immer fest. Rahme dein Puzzle nach dem Puzzeln ein und du hast deinen Moment bei dir zuhause an der Wand.</p>' +
        '<div class="tee-rahmen-image-grid">' +
          '<img src="' + (imgs.rahmenBild || '') + '" alt="Rahmen mit Bild" />' +
          '<img src="' + (imgs.rahmenHinten || '') + '" alt="Rahmen R\u00fcckseite" />' +
        '</div>' +
        '<p>Unsere Rahmen sind aus hochwertigem Holz und gibt es in verschiedenen Farben \u2013 passend zu jedem Einrichtungsstil.</p>' +
      '</div>';

    infoPopup.querySelector('.wm-rahmen-info__close').addEventListener('click', closeRahmenInfoPopup);

    document.body.appendChild(infoOverlay);
    document.body.appendChild(infoPopup);

    requestAnimationFrame(function() {
      infoOverlay.classList.add('active');
      infoPopup.classList.add('active');
    });

    if (mobile) document.body.style.overflow = 'hidden';
  }

  function closeRahmenInfoPopup() {
    if (!infoPopup) return;
    infoOverlay.classList.remove('active');
    infoPopup.classList.remove('active');
    setTimeout(function() {
      if (infoOverlay && infoOverlay.parentNode) infoOverlay.parentNode.removeChild(infoOverlay);
      if (infoPopup && infoPopup.parentNode) infoPopup.parentNode.removeChild(infoPopup);
      infoOverlay = null;
      infoPopup = null;
    }, 300);
    document.body.style.overflow = '';
  }
})();
